import React from 'react';
import BDCalculator from '@/components/BDCalculator';

export default function BDCalculatorPage() {
    return (
        <div className="space-y-6" data-testid="bd-calculator-page">
            <div>
                <h1 className="text-2xl font-bold">BD Equity Calculator</h1>
                <p className="text-muted-foreground text-sm">Quick equity calculation tool for customer calls</p>
            </div>
            <div className="max-w-2xl">
                <BDCalculator />
            </div>
        </div>
    );
}
